import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import QuickOverview from './QuickOverview';
import HighlightedBlock from './HighlightedBlock';
import PromotedBlock from './PromotedBlock';
import Copyright from './Copyright';

const Footer = () => (
  <footer className="Footer">
    <Container>
      <Row>
        <Col>
          <QuickOverview />
          <HighlightedBlock />
          <PromotedBlock />
          <Copyright />
        </Col>
      </Row>
    </Container>
  </footer>
);

export default Footer;